
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 96 96","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"12.25","y":"20.25","width":"71.5","height":"55.5","rx":"7.75","stroke":"currentColor","stroke-width":"2.5"}}),_c('circle',{attrs:{"cx":"34","cy":"40","r":"6","fill":"currentColor","fill-opacity":".55"}}),_c('path',{attrs:{"d":"M15 66.5l18-18a5 5 0 017 0l14 14","stroke":"currentColor","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M48 62.5L58.5 52a5 5 0 017 0L81 67.5","stroke":"currentColor","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    